




































import { Component, Vue, Watch } from 'vue-property-decorator'
import { membershipState } from '../../store/modules/MembershipState'
import { getUserInfo, ssoLogin } from '../../modules/util/SapUtil'
import RegisteredUserInfo from '../../modules/class/RegisteredUserInfo'
import {
  fillForm,
  checkForm,
  addOpenAccordionEvent,
  openAccordion
} from '../../modules/util/WebformElement'
import { createCustomEvent } from '../../modules/CustomEvent'

@Component
export default class LoginiconWebform extends Vue {
  private readonly vueid = 'vue_login_icon_webform'

  // -------------------------------------------------------------------------------------------------------------------
  // Props
  get isLogin(): boolean {
    return membershipState.isLogin
  }

  get userInfo(): RegisteredUserInfo {
    return membershipState.userInfo
  }

  // ------------------------------------------------------------------------------------------------
  // hooks
  private created() {
    // アコーディオンを開かせるイベントを追加
    addOpenAccordionEvent()
  }

  // -------------------------------------------------------------------------------------------------------------------
  // methods

  /**
   * ログイン画面に遷移する
   */
  private signin() {
    if (!this.isLogin) {
      // login modal show
      ssoLogin(window.location.href, 'gigya-login-screen')
    }
  }

  /**
   * 会員情報を埋める
   */
  private async fillUserInfo() {
    // フォーム項目に代入
    fillForm('#edit-first-name', this.userInfo.firstname, true)
    fillForm('#edit-last-name', this.userInfo.lastname, true)
    fillForm('#edit-first-kana-name', this.userInfo.firstKanaName, false)
    fillForm('#edit-last-kana-name', this.userInfo.lastKanaName, false)
    fillForm('#edit-email-address', this.userInfo.email, true)
    fillForm('#edit-organization', this.userInfo.organization, false)
    fillForm('#edit-job-role', this.userInfo.jobRoles, false)
    fillForm('#edit-country-region', this.userInfo.countryRegion, true)
    fillForm('#edit-address', this.userInfo.address, false)
    fillForm('#edit-city', this.userInfo.city, false)
    fillForm('#edit-state', this.userInfo.state, false)
    fillForm('#edit-zip-postal-code', this.userInfo.zipCode, false)
    fillForm('#edit-phone', this.userInfo.phone, false)
    fillForm('#edit-mobile-phone', this.userInfo.mobilePhone, false)
    fillForm('#edit-department', this.userInfo.department, false)
    fillForm('#edit-industry', this.userInfo.industry, false)
    checkForm(
      '#edit-email-subscription-flag',
      this.userInfo.emailSubscription,
      false,
      true
    )

    // Webformに島津IDの情報をセットしたhookを実施
    createCustomEvent('webform-fill-user-info-alter', {})
  }

  // formでのログイン判定に使用
  @Watch('isLogin')
  onIsLoginChanged(newIsLogin: boolean): void {
    if (newIsLogin) {
      getUserInfo()
    }
    checkForm('#edit-logined', this.isLogin, false, true)
    if (this.isLogin) {
      openAccordion()
    }
  }

  @Watch('userInfo', { deep: true })
  onChangeUserInfo(): void {
    if (this.userInfo.email !== '') {
      this.fillUserInfo()
    }
  }
}
